export const entryNodeKey = (entry) => entry.productHierarchyNodeId ?? entry.categoria ?? "__all__";